/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelBookingCreateResponseRedirect } from '../../models/travel-booking-create-response-redirect';

export interface BookingControllerCreateStripePayment$Params {
  payment_identifier: string;
}

export function bookingControllerCreateStripePayment(http: HttpClient, rootUrl: string, params: BookingControllerCreateStripePayment$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerCreateStripePayment.PATH, 'post');
  if (params) {
    rb.path('payment_identifier', params.payment_identifier, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelBookingCreateResponseRedirect;
      }>;
    })
  );
}

bookingControllerCreateStripePayment.PATH = '/booking/pay/{payment_identifier}';
